<template>

    <div>

        <div class="info-status" v-if="rates && rates.length == 0">{{statusMessage}}</div>

        <div class="rates">
            <b-list-group>
                <b-list-group-item v-for="(item, index) in rates" :key="index" :id="`place-${index}`">
                    <div class="place-preview">
                        <div class="top">
                            <div class="image">
                                <img :src="item.preview">
                            </div>
                            <div class="address">
                                <a class="title"
                                   @click="onPlaceClick(item, `#place-${index}`)">{{item.name}}</a>
                                <address>
                                    <span>{{item.address}}</span>
                                </address>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="you-vote">
                                <span class="title" v-text="translate('YourVotes')"></span>
                                <b>{{item.my_rates_count}}</b>
                            </div>
                            <div class="users-vote">
                                <span class="title" v-text="translate('OtherVotes')"></span>
                                <ul>
                                    <li>
                                        <div class="image cool">
                                            <img src="../assets/icons/smile-simple.svg" alt="">
                                        </div>
                                        <b>{{item.rates_info.rate3}}</b>
                                    </li>
                                    <li>
                                        <div class="image soso">
                                            <img src="../assets/icons/normal-simple.svg" alt="">
                                        </div>
                                        <b>{{item.rates_info.rate2}}</b>
                                    </li>
                                    <li>
                                        <div class="image meh">
                                            <img src="../assets/icons/sad-simple.svg" alt="">
                                        </div>
                                        <b>{{item.rates_info.rate1}}</b>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>

            <infinite-loading @infinite="getList">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </div>

    </div>

</template>
<script>
    import InfiniteLoading from 'vue-infinite-loading';
    import errorMixin from '@/mixins/errorMixin';
    import scrollToMixin from '@/mixins/scrollToMixin';
    import {mapActions, mapMutations, mapState} from 'vuex';
    import logAnalyticsEvent from '@/helpers/analytics'
    import _ from 'lodash'

    export default {
        name: 'list',
        mixins: [mixin, errorMixin, scrollToMixin],
        components: {
            InfiniteLoading
        },
        data() {
            return {
                getListPlacesPage: 1,
                getListMyPlacesPage: 1,
                statusMessage: this.translate('statusMessage'),
                infinityState: undefined,
                placeCheckbox: true,
                fixeNavBool: false,
            }
        },

        computed: {
            ...mapState({
                page: state => state.place.page,
                searchText: state => state.search.searchText,
                rates: state => state.place.rates,
                isCompleteInfinityList: state => state.place.isCompleteInfinityList,
            })
        },

        watch: {
            searchText(value) {
                if (value.trim().length === 0) {
                    this.infinityState.reset()
                }

                clearInterval(this.timerId)

                this.timerId = setTimeout(() => {
                    this.statusMessage = this.translate('statusMessage')
                    this.fetchPlacesList({
                        isMyPlaces: true,
                        page: 1,
                        searchText: value,
                    }).then((response) => {
                        this.setRates(response.places)
                        if (response.places.length === 0) {
                            this.statusMessage = this.translate('No_votes');
                        }
                        this.infinityState.loaded();
                    })

                }, 350);

            }
        },

        mounted() {

            if (localStorage.getItem('access_token') == undefined) {
                this.$router.push('/sign-in');
                return false;
            }

            if (this.page > 1) {
                this.setPlacePage(1)
            }
        },

        methods: {
            ...mapActions({
                fetchPlacesList: 'place/fetchPlacesList'
            }),

            ...mapMutations({
                setChekboxPlaceType: 'place/setChekboxPlaceType',
                setPlacePage: 'place/setPlacePage',
                toggleSearchPanel: 'search/toggleSearchPanel',
                saveScrolledItem: 'saveScrolledItem',
                setRates: 'place/setRates',
                addRates: 'place/addRates',
                setCompleteInfinityList: 'place/setCompleteInfinityList'
            }),

            onPlaceClick(item, idToScroll) {
                logAnalyticsEvent('places_place_click')
                this.saveScrolledItem(idToScroll)
                this.$router.push({name: 'place', params: {id: item.uid}})
            },

            async getList($state, isSearch) {
                if (this.infinityState == undefined) {
                    this.infinityState = $state;
                }
                if (isSearch) {
                    this.setRates([])
                    this.setPlacePage(1)
                }

                if (this.isCompleteInfinityList) this.infinityState.complete()
                if (!this.isCompleteInfinityList) {
                    try {
                        const response = await this.fetchPlacesList({
                            isMyPlaces: true,
                            page: this.page,
                            searchText: this.searchText
                        })

                        if (response.success) {
                            this.setPlacePage(this.page + 1)
                            const isSamePlaceList = _.isEqual(response.places, this.rates)
                            if (this.rates.length === 0 || response.places.length === 0 || isSamePlaceList) {
                                this.setRates(response.places)
                            } else {
                                response.places.forEach((item) => {
                                    this.addRates(item)
                                })
                            }

                            if (response.places.length == 0) {
                                this.statusMessage = this.translate('No_votes');
                            }
                            if (response.places.length === 10) {
                                this.infinityState.loaded();
                            } else {
                                this.infinityState.complete();
                                this.setCompleteInfinityList(true)
                            }
                        } else {
                            this.showErrorModal()
                        }
                    } catch (error) {
                        this.infinityState.complete();
                    }
                }

            },


            getListFormCheckbox() {
                logAnalyticsEvent('places_show_your_votes_only', {
                    checked: this.placeCheckbox
                })
                this.setPlacePage(1)
                this.infinityState.reset();
                this.setRates([])
                setTimeout(() => {
                    this.setChekboxPlaceType(this.placeCheckbox)
                    localStorage.setItem('placeCheckbox', this.placeCheckbox)
                }, 100)
            },

        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.searchText.length) {
                    vm.toggleSearchPanel(true)
                    vm.setPlacePage(1)
                }

                if (vm.scrolledItem && from.name === 'place') {
                    vm.$scrollTo(vm.scrolledItem, -1, vm.scrollOptions)
                    vm.saveScrolledItem(null)
                }
            })
        }
    }
</script>

<style scoped>
    .header-space {
        height: 4em;
    }

    .checkbox {
        padding: 0.6em 1em;
        background: #F3F3F3;
        box-shadow: 0 0.1em 0.3em 0em rgba(0, 0, 0, 0.1);
        font-size: .95em;
    }

    .list-group-item {
        display: flex;
        justify-content: space-between;
    }

    .info-status {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        width: 90vw;
    }

    .list-group-item .place_rate {
        width: 3.5em;
        /*transform: scale(1.9);*/
    }

    .list-group-item img {
        width: 1.5em;
        height: 1.5em;
        transform: scale(1.5);
        margin-right: 1em;
    }

    .place_name {
        width: 100%;
        max-width: calc(100% - 3.5em);
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .list-group-item span {
        color: #000;
    }

    .spiner-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

</style>
